import React from 'react';
import PropTypes from 'prop-types';
import HeaderMenu from './HeaderMenu/HeaderMenu';
import { buildEverfiAdminNavigationMenu } from '../menus/everfiAdminNavigation';
import { cportalUserNavigation } from '../menus/cportalUserNavigation';
import { filterMenu, withPermissionIndicator } from '../menus/menuHelper';

/**
 * Wraps HeaderMenu and builds menuData from slug + context props,
 * removing the dependency on foundry-universal_navigation gem.
 */
const HeaderMenuWithMenuData = props => {
  const { slug, admin, user, organization, adminifiDomain, dashifiDomain,
    logoutPath, currentRuleSetName, currentUrl, ...rest } = props;

  let menuData;
  if (slug === 'everfi_admin_navigation') {
    menuData = buildEverfiAdminNavigationMenu({ admin, adminifiDomain, logoutPath });
  } else if (slug === 'cportal_user_navigation') {
    const menuDefinition = cportalUserNavigation({ dashifiDomain, adminifiDomain, logoutPath });
    const filtered = filterMenu(menuDefinition, { user, organization, currentRuleSetName });
    menuData = withPermissionIndicator(filtered, currentUrl);
  } else {
    menuData = { slug, submenu_items: [] };
  }

  return <HeaderMenu {...rest} adminifiDomain={adminifiDomain} dashifiDomain={dashifiDomain} menuData={menuData} />;
};

HeaderMenuWithMenuData.propTypes = {
  slug: PropTypes.string.isRequired,
  admin: PropTypes.object,
  user: PropTypes.object,
  organization: PropTypes.object,
  adminifiDomain: PropTypes.string,
  dashifiDomain: PropTypes.string,
  logoutPath: PropTypes.string,
  currentRuleSetName: PropTypes.string,
  currentUrl: PropTypes.string,
};

export default HeaderMenuWithMenuData;
